export const DEFAULT_TAX_RATE = 10;

export function calculateTax(price: number, taxRate: number | undefined) {
  const taxRateNum = taxRate ?? 0;
  return Math.round(price * (taxRateNum * 0.01));
}
